import PropTypes from 'prop-types';
import React from 'react';

import {Field} from 'redux-form'
import clsx from "clsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/pro-light-svg-icons/faEye";
import {faEyeSlash} from "@fortawesome/pro-light-svg-icons/faEyeSlash";

const renderField = (
    {
        noValidation, label, onKeyDown, disabled, input, fieldId, placeholder,
        isOptional, autocomplete, forceValidation, type, togglePasswordCallback,
        showPassword, hint, meta: {touched, active, visited, error, warning}
    }
) => {

    const showValidationResult = !noValidation && ((touched || forceValidation));

    let showPasswordButton = null;
    if (togglePasswordCallback) {
        showPasswordButton = (
            <a className={'labeled-input__show-password'} onClick={(e) => {
                togglePasswordCallback();
            }}>
                {showPassword ? <FontAwesomeIcon fixedWidth={true} icon={faEyeSlash}/> : <FontAwesomeIcon fixedWidth={true} icon={faEye}/>}
            </a>
        )
    }
    return (
        <div className={clsx('labeled-input', active && 'labeled-input--focus', showValidationResult && error && 'labeled-input--error', showValidationResult && !error && 'labeled-input--valid')}>
            <label htmlFor={fieldId}>{label} {label && isOptional ? <span>{"(optional)"}</span> : ''}</label>
            {showPasswordButton}
            <input onKeyDown={onKeyDown ? onKeyDown : null} disabled={disabled} placeholder={placeholder} {...input} autoComplete={autocomplete} type={type}/>
            {(hint || (showValidationResult)) && <div className="hint">{((touched || (forceValidation && error)) && error) ? error : hint}</div>}
        </div>
    )
}

function LabeledInput(props) {
    return <Field onKeyDown={props.onKeyDown} name={props.fieldId} forceValidation={props.forceValidation} component={renderField} props={props}/>;
}

LabeledInput.propTypes = {
    fieldId: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    isOptional: PropTypes.bool,
    hint: PropTypes.string,
    forceValidation: PropTypes.bool,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    onKeyDown: PropTypes.func
};

LabeledInput.defaultProps = {
    forceValidation: false,
    type: "text"
};

export default LabeledInput


/** WEBPACK FOOTER **
 ** ./src/components/forms/LabeledInput.js
 **/